<template>
    <div class="container">
        <div v-if="!loading" class="recommended-bands justify-content-center">
            <div class="row" v-for="bandChunk in bandChunks" :key="bandChunk.id">
                <div v-for="band in bandChunk.bands" :key="band.id" class="col-md-4 d-flex">
                    <a class="recommended-bands__band-card" :href="`/fi/band/${band.slug}`">
                        <div class="recommended-bands__band-card__image-container">
                            <div
                                class="recommended-bands__band-card__image-container__image"
                                v-if="band.defaultProfileImage"
                                :style="{ backgroundImage: 'url(\'' + band.defaultProfileImage +'\')' }">
                            </div>
                            <div class="recommended-bands__band-card__image-container__image" v-else>
                                <i class="far fa-image"></i>
                            </div>
                        </div>
                        <h3>
                            {{ band.name }}
                        </h3>
                        <div class="recommended-bands__band-card__info">
                            <div class="recommended-bands__band-card__info__stars">
                                <Stars :rating="band.bandRank" />
                            </div>
                            <p class="recommended-bands__band-card__info__price">
                                {{ formatPrice(band) }}
                            </p>

                            <p class="recommended-bands__band-card__info__slogan">
                                {{ band.slogan }}
                            </p>
                        </div>
                    </a>
                </div>
            </div>
            <div class="row justify-content-center recommended-bands__navigation">
                <div class="col-md-4">
                    <div @click="previousPage()" :class="{ disabled: isPreviousButtonDisabled }">
                        <i class="fa fa-angle-double-left"></i>
                    </div>
                    <div @click="nextPage()">
                        <i class="fa fa-angle-double-right"></i>
                    </div>
                </div>
            </div>
        </div>
        <div class="row justify-content-center" v-else>
            <div class="panel-loading col-md-4"></div>
        </div>
    </div>
</template>

<script>
import { chunk } from 'lodash';
import ApiCall from '../modules/ApiCall';
import Routes from '../modules/Routes';
import Stars from './Stars';

const recommendationPageSize = 6;

export default {
    components: {
        Stars
    },
    data() {
        return {
            bands: [],
            loading: false,
            page: 1,
        };
    },
  props: {
     city: {
        type: String,
        default: undefined,
      },
      audience: {
        type: String,
        default: undefined,
     }
  },

    mounted() {
        this.fetchRecommendations(this.page);
    },

    computed: {
        bandChunks() {
            return chunk(this.bands, 3).map((bands, index) => ({
                id: index,
                bands,
            }));
        },

        isPreviousButtonDisabled() {
            return this.page === 1;
        },
    },

    methods: {
        async fetchRecommendations(page) {
            this.loading = true;
            const response = await ApiCall.getData(
                Routes.getRoute('_public_api_recommended_bands'),
                {
                  page,
                  limit: recommendationPageSize,
                  city: this.city,
                  audience: this.audience
                },
            );

            this.bands = response.bands;
            this.loading = false;
        },
        nextPage() {
            this.page = this.page + 1;
            this.fetchRecommendations(this.page);
        },
        previousPage() {
            if (this.isPreviousButtonDisabled) {
                return;
            }

            this.page = this.page - 1;
            this.fetchRecommendations(this.page);
        },
        formatPrice(band) {
            return `${band.price} €`;
        }
    },
};
</script>
